import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const IntegrationsHelp = () => {
  const isMdScreen = IsMdScreen();

  return (
    <Stack direction="row" spacing={2} sx={{ height: '100%' }}>
      <ShContainer maxWidth='xl' sx={{ flex: 1 }}>
        <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
          Integration Management
        </ResourceTypography>
        <ResourceTypography variant="body1" paragraph>
          Connect your hiring platform with other tools and systems to streamline your workflow.
          Set up and manage integrations with HRIS, ATS, and other business applications.
        </ResourceTypography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          HRIS Integration
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Connect with popular HRIS systems to sync candidate data, employee information,
          and hiring workflows. Automate data transfer between systems.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Calendar Integration
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Sync with calendar applications to manage interview schedules and availability.
          Automatically update calendars when interviews are scheduled or changed.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Job Board Integration
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Connect with popular job boards to post openings and receive applications.
          Track application sources and manage postings from a single platform.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          API Configuration
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Configure custom API integrations to connect with your internal systems.
          Set up webhooks and automate data exchange between platforms.
        </Typography>

        <Box paddingTop={2} paddingBottom={3}>
          <ShButton
            component={RouterLink}
            to="/employer/settings/integrations"
            color="primary"
            variant="contained"
          >
            Manage Integrations
          </ShButton>
        </Box>
      </ShContainer>
      {!isMdScreen && <CommonQuestionSidebar />}
    </Stack>
  );
};

export default IntegrationsHelp; 